module.exports = __webpack_public_path__ + "img/brand-block-1.d1e6cfc8.png";